import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import style from './CandlePatternDetailsComponent.module.css';

export const CandlePatternDetailsComponent = observer(({ details }) => {
  return (
    <td className={style.container}>
      {details.map(({ current, sequence, id, achieved, showPartialBox }) => {
        if (showPartialBox) {
          return <div key={id} className={style[showPartialBox]}>{sequence}</div>;
        }
        if (achieved) {
          return <div key={id} className={style.achieved}>{sequence}</div>;
        }
        return (
          <div className={current ? style.current : style.notCurrent} key={id}>
            {sequence}
          </div>
        );
      })}
    </td>
  );
});

CandlePatternDetailsComponent.propTypes = {
  details: PropTypes.array,
};

/*
[{
      current: false,
      sequence: 2U
    }, {
      current: true,
      sequence: 2U
    }]
*/
